const STATUS_ONLINE = 'online'
const STATUS_OFFLINE = 'offline'

const ACTION_REBOOTING = 'rebooting'
const ACTION_FLASHING = 'flashing'
const ACTION_DOWNLOADING_FIRMWARE = 'downloading_firmware'

const ACTION_ERROR_INVALID_FLASH_DATA = 'invalid_flash_data'
const ACTION_ERROR_DOWNLOAD_FAILED = 'download_failed'
const ACTION_ERROR_DOWNLOAD_WRITE_FAILED = 'download_write_failed'
const ACTION_ERROR_FLASH_INIT_FAILED = 'flash_init_failed'

const actionData = {
  [ACTION_REBOOTING]: {
    text: 'Rebooting'
  },
  [ACTION_FLASHING]: {
    text: 'Flashing'
  },
  [ACTION_DOWNLOADING_FIRMWARE]: {
    text: 'Downloading firmware'
  },
  [ACTION_ERROR_DOWNLOAD_FAILED]: {
    text: 'Firmware download failed',
    color: 'error',
    progress: false
  },
  [ACTION_ERROR_INVALID_FLASH_DATA]: {
    text: 'Invalid flash data',
    color: 'error',
    progress: false
  },
  [ACTION_ERROR_DOWNLOAD_WRITE_FAILED]: {
    text: 'Download write failed',
    color: 'error',
    progress: false
  },
  [ACTION_ERROR_FLASH_INIT_FAILED]: {
    text: 'Flash init failed',
    color: 'error',
    progress: false
  }
}

const emptyModel = {
  description: '',
  client_id: undefined,
  is_static_network: false,
  static_network_configuration: {
    ipaddress: null,
    subnetmask: null,
    gateway: null,
    dns: [''],
    ntp: ['']
  },
  is_wifi_enabled: false,
  wifi_configuration: {
    ssid: null,
    password: null,
    is_hidden: false
  },
  is_ntp_manual: false,
  ntp_configuration: {
    servers: ['']
  },
  is_proxy_enabled: false,
  proxy_configuration: {
    proto: 'http',
    host: null,
    port: null,
    username: null,
    password: null
  },
  use_download_relay: false,
  download_relay: null,
  has_manual_hostname: false,
  hostname: null,
  destination: null
}

const emptyFilters = {
  client_id: undefined,
  radio_id: undefined,
  player_status: undefined,
  description: '',
  type: undefined
}

export default {
  emptyModel,
  emptyFilters,
  STATUS_ONLINE,
  STATUS_OFFLINE,
  ACTION_REBOOTING,
  ACTION_FLASHING,
  actionData
}
